export default function Button() {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          boxShadow: 'none',
        },
        sizeLarge: {
          height: '56px',
        },
      },
    },
  };
}
